import React from 'react'

export default function AddFollowupLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()

        const customEvent = new CustomEvent('support-chat-action', { detail: { action: 'add_followup' } })
        window.dispatchEvent(customEvent)
      }}
    >
      {children}
    </a>
  )
}
